export default {
    content: {},
};
